import { httpsCallable } from "firebase/functions";
import {fetchHistoricalWeatherRaw,type HistoricalWeatherRequest} from "./historicalWeather";
import { functions } from "../firebase/client";
export type WeatherConditionKey =
  | "climate.weather.clear"
  | "climate.weather.partlyCloudy"
  | "climate.weather.fog"
  | "climate.weather.drizzle"
  | "climate.weather.rain"
  | "climate.weather.snow"
  | "climate.weather.showers"
  | "climate.weather.thunderstorm"
  | "climate.weather.unknown";

export type AutomaticWeatherDay = {
  date: string;
  query: string;
  resolvedName: string;
  minTemp: number;
  maxTemp: number;
  weatherCode: number;
  conditionKey: WeatherConditionKey;
  icon: string;
  hourly?: Array<{ time: string; temperature: number; apparent: number; precipitation: number; wind: number }>;
  isHistorical?: boolean;
  precipitationUnit?: "mm" | "%";
};

function weatherDescriptor(code: number): { key: WeatherConditionKey; icon: string } {
  if (code === 0) return { key: "climate.weather.clear", icon: "☀️" };
  if ([1, 2, 3].includes(code)) return { key: "climate.weather.partlyCloudy", icon: "⛅" };
  if ([45, 48].includes(code)) return { key: "climate.weather.fog", icon: "🌫️" };
  if ([51, 53, 55, 56, 57].includes(code)) return { key: "climate.weather.drizzle", icon: "🌦️" };
  if ([61, 63, 65, 66, 67].includes(code)) return { key: "climate.weather.rain", icon: "🌧️" };
  if ([71, 73, 75, 77, 85, 86].includes(code)) return { key: "climate.weather.snow", icon: "🌨️" };
  if ([80, 81, 82].includes(code)) return { key: "climate.weather.showers", icon: "🌦️" };
  if ([95, 96, 99].includes(code)) return { key: "climate.weather.thunderstorm", icon: "⛈️" };
  return { key: "climate.weather.unknown", icon: "🌤️" };
}

export async function fetchAutomaticWeather(input: { requests: Array<{ date: string; query: string }>; language: string }): Promise<AutomaticWeatherDay[]> {
  const response = await httpsCallable<typeof input, { days: Array<Omit<AutomaticWeatherDay, "conditionKey" | "icon">> }>(functions, "getMundelyWeather")(input);
  return response.data.days.map(day => { const desc = weatherDescriptor(day.weatherCode); return { ...day, conditionKey: desc.key, icon: desc.icon }; });
}

/** Historical conditions use Open-Meteo's past-day data; the Firebase callable rejects past dates. */
export async function fetchHistoricalWeather(input:{requests:HistoricalWeatherRequest[];language:string;includeHourly?:boolean;signal?:AbortSignal}):Promise<AutomaticWeatherDay[]>{
 const past=await fetchHistoricalWeatherRaw(input);
 return past.map(day=>{const descriptor=weatherDescriptor(day.weatherCode);return {...day,icon:descriptor.icon,conditionKey:descriptor.key};});
}
